import { Logo } from "./Logo";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
  <footer
    id="privacy"
    data-testid="site-footer"
    className="border-t border-cream/10 bg-ink py-14 text-cream"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <Logo light />
          <p className="mt-4 text-sm leading-relaxed text-cream/60">
            Google Business Profile optimization for local businesses that want
            their listing to pull its weight.
          </p>
        </div>
        <nav aria-label="Footer" className="flex flex-col gap-3">
          {[
            { label: "The Offer", id: "#offer" },
            { label: "How It Works", id: "#how-it-works" },
            { label: "Free Audit", id: "#free-audit" },
            { label: "FAQ", id: "#faq" },
          ].map((l) => (
            <button
              key={l.id}
              data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => scrollToId(l.id)}
              className="text-left text-sm text-cream/60 transition-colors duration-300 hover:text-cream"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="max-w-xs">
          <p className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-cream/80">
            Privacy
          </p>
          <p className="mt-3 text-sm leading-relaxed text-cream/60">
            Audit requests are used only to prepare your audit and contact you
            about it. A full privacy policy will be published here before
            launch.{" "}
            <span className="text-cream/40">
              [Placeholder — link your privacy policy page]
            </span>
          </p>
        </div>
      </div>
      <div className="mt-12 border-t border-cream/10 pt-8">
        <p className="text-xs leading-relaxed text-cream/40">
          © 2026 LocalLift. All rights reserved. Google Business Profile and
          Google Maps are trademarks of Google LLC. LocalLift is not affiliated
          with or endorsed by Google.
        </p>
      </div>
    </div>
  </footer>
);
